import { ReportView } from 'src/app/features/reports/models';

export class LoadReportsAction {
  static readonly type = '[Reports] Load Reports';

  constructor(public payload: { clientId: string }) { }
}

export class LoadReportsSuccessAction {
  static readonly type = '[Reports] Load Reports Success';

  constructor(public payload: { reports: ReportView[] }) { }
}

export class LoadReportsFailAction {
  static readonly type = '[Reports] Load Reports Fail';
}

export class LoadReportsForUserAction {
  static readonly type = '[Reports] Load Reports For User';

  constructor(public payload: { clientId: string, userRef: string }) { }
}

export class LoadReportsForUserSuccessAction {
  static readonly type = '[Reports] Load Reports For User Success';

  constructor(public payload: { reports: ReportView[] }) { }
}

export class LoadReportsForUserFailAction {
  static readonly type = '[Reports] Load Reports For User Fail';
}

export class AddUserToReportAction {
  static readonly type = '[Reports] Add User To Report';

  constructor(public payload: { clientId: string, userRef: string, reports: ReportView[] }) { }
}

export class AddUserToReportSuccessAction {
  static readonly type = '[Reports] Add User To Report Success';

  constructor() { }
}

export class AddUserToReportFailAction {
  static readonly type = '[Reports] Add User To Report Fail';
}

export class UpdateReportsForUserAction {
  static readonly type = '[Reports] Update Reports For User';

  constructor(public payload: { clientId: string, userRef: string, reports: ReportView[] }) { }
}

export class UpdateReportsForUserSuccessAction {
  static readonly type = '[Reports] Update Reports For User Success';

  constructor() { }
}

export class UpdateReportsForUserFailAction {
  static readonly type = '[Reports] Update Reports For User Fail';
}
